import { render, staticRenderFns } from "./IqcDataReport.vue?vue&type=template&id=104e7938&scoped=true&"
import script from "./IqcDataReport.vue?vue&type=script&lang=js&"
export * from "./IqcDataReport.vue?vue&type=script&lang=js&"
import style0 from "./IqcDataReport.vue?vue&type=style&index=0&id=104e7938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e7938",
  null
  
)

export default component.exports